import React from 'react';

export default function SkillChecklistModal({ skillDetail, sessionId, onClose, onRecordItem, onCompleteSkillTest }) {
  if (!skillDetail) return null;

  return (
    <div
      className="modal-overlay"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        zIndex: 1001,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <div
        className="modal-content"
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: 24,
          minWidth: 400,
          maxWidth: 500,
          maxHeight: '80vh',
          overflow: 'auto',
          boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
          position: 'relative'
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 16,
            fontSize: 24,
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>

        <h3>{skillDetail.name}</h3>
        <p style={{ color: '#666', fontSize: '0.9em' }}>{skillDetail.description}</p>

        <div style={{ marginBottom: 16, padding: '8px 12px', background: '#f8f9fa', borderRadius: 6 }}>
          <strong>Pass Criteria:</strong> {skillDetail.pass_criteria}
          {skillDetail.default_time_limit_seconds && (
            <span style={{ marginLeft: 12 }}>
              <strong>Time Limit:</strong>{' '}
              {Math.floor(skillDetail.default_time_limit_seconds / 60)}:
              {(skillDetail.default_time_limit_seconds % 60).toString().padStart(2, '0')}
            </span>
          )}
        </div>

        <h4>Checklist Items</h4>
        <div>
          {skillDetail.checklist?.map((item) => (
            <div
              key={item.id}
              style={{
                padding: '10px 12px',
                background: '#f8f9fa',
                borderRadius: 6,
                marginBottom: 8,
                borderLeft: item.is_critical ? '4px solid #dc3545' : '4px solid #28a745'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                <div style={{ flex: 1 }}>
                  <span>{item.description}</span>
                  {item.is_critical && (
                    <span style={{ marginLeft: 8, color: '#dc3545', fontSize: '0.8em', fontWeight: 'bold' }}>
                      ⚠️ CRITICAL
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 4 }}>
                  <button
                    className="btn pass"
                    onClick={() => onRecordItem(sessionId, skillDetail.assignmentId, item.id, 'pass')}
                    style={{ padding: '4px 12px', minWidth: 40 }}
                  >
                    ✓
                  </button>
                  <button
                    className="btn fail"
                    onClick={() => onRecordItem(sessionId, skillDetail.assignmentId, item.id, 'fail')}
                    style={{ padding: '4px 12px', minWidth: 40 }}
                  >
                    ✗
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
          <button
            className="btn pass"
            onClick={() => onCompleteSkillTest(sessionId, skillDetail.assignmentId, 'pass')}
            style={{ flex: 1 }}
          >
            ✅ Mark Pass
          </button>
          <button
            className="btn fail"
            onClick={() => onCompleteSkillTest(sessionId, skillDetail.assignmentId, 'fail')}
            style={{ flex: 1 }}
          >
            ❌ Mark Fail
          </button>
        </div>

        <button className="btn" onClick={onClose} style={{ marginTop: 12, width: '100%' }}>
          Close Checklist
        </button>
      </div>
    </div>
  );
}
